export default "__VITE_ASSET__Bq7B_kq5__"